import * as React from 'react';
import { Seats } from '../../../../../../CheckoutAdditionalService/components';
import { GdsAggregationServiceGroup } from '../../../../../types';
import { SelectedSeatsServiceType } from '../../../../../store/selectedServices/reducers';
import { useTheme } from '../../../../../../theme';
import cn from 'classnames';

interface Props {
	segmentId?: string;
	service?: GdsAggregationServiceGroup;
	hideCard?: boolean;
}

const AggregatedSeats: React.FC<Props> = ({ segmentId, service, hideCard }) => {
	const theme = useTheme('Checkout').ServicesAggregationPage;

	const icons = ['Services/Seat Selection', 'Amenity/Seat_Window'];

	return (
		<Seats
			aggregationMode={true}
			isCheckinAvailable={false}
			segmentId={segmentId}
			minPrice={service.minPrice}
			totalPrice={service.totalPrice}
			isSelected={!!service.selectedServices.length}
			aggregationIcons={icons}
			className={cn({
				[theme.hideServiceCard]: hideCard
			})}
		>
			{service.selectedServices.length > 0 && (
				<div className={theme.seatsService}>
					{service.selectedServices.map(service => {
						return <span>{(service.service as SelectedSeatsServiceType).number}</span>;
					})}
				</div>
			)}
		</Seats>
	);
};

export default AggregatedSeats;
